import { useUserState } from '@juvare/contact-management/ui/hooks';
import { isTrainFeatureEnabled } from '../utils';
import { useDeploymentFilters } from './useDeploymentFilters';
import { useFeatureFlags } from './useFeatureFlags';
import { useAccountsLocationInformationFilters } from './useLocationInformationFilters';
import { useOccupationFilters } from './useOccupationFilters';
import { useQualificationFilters } from './useQualificationFilters';
import { useTrainCourseFilters } from './useTrainCourseFilters';
export function useExtendedCredentialingAccountsFilters() {
    const userState = useUserState();
    const { occupations: occupationEnabled, tribe: locationEnabled, deploymentAndPriorCommitments: deploymentEnabled, skillsAndTrainings: skillsAndTrainingEnabled, } = useFeatureFlags();
    const { occupationFilters } = useOccupationFilters();
    const { locationFilters } = useAccountsLocationInformationFilters();
    const { deploymentFilters } = useDeploymentFilters();
    const { qualificationFilters } = useQualificationFilters();
    const { trainCourseFilters } = useTrainCourseFilters();
    const extendCredentialingFilters = (builder, options) => {
        if (occupationEnabled) {
            occupationFilters(builder);
        }
        if (locationEnabled) {
            locationFilters(builder, options === null || options === void 0 ? void 0 : options.regionEnabled);
        }
        if (deploymentEnabled) {
            deploymentFilters(builder);
        }
        if (skillsAndTrainingEnabled) {
            qualificationFilters(builder);
        }
        if (isTrainFeatureEnabled(userState)) {
            trainCourseFilters(builder);
        }
    };
    return {
        extendCredentialingFilters,
    };
}
